export default "__VITE_ASSET__bfe837b8__"